import React from "react";
import styles from "./benefitdata.module.scss";
import { Benefit } from "../../sections/benefits";

type BenefitDataProps = {
  data: Benefit;
};

const BenefitData: React.FC<BenefitDataProps> = ({ data }) => {
  return (
    <div className={styles.benefitData}>
      <div className={styles.iconContainer}>
        {data.customIcon ? (
          <img src={data.customIcon} alt={data.title} className={styles.icon} />
        ) : (
          <i className={`pe-7s-${data.icon} pe-7s ${styles.icon}`}></i>
        )}
      </div>
      <div className={styles.descriptionContainer}>
        <h3 className={styles.subtitle}>{data.title} </h3>
        <p className={styles.description}>{data.description}</p>
      </div>
    </div>
  );
};

export default BenefitData;
